module.exports = __webpack_public_path__ + "static/Foodservice-Photo1-2f0c5024fcfdecc04ee3ecb0190345ee.png";